import { Modal } from 'tailwindcss-stimulus-components'

export default class ModalController extends Modal {
  static targets = ['turboFrame', 'window']

  closeBackground(event) {
    if (this.hasWindowTarget && this.windowTarget.getAttribute('data-close-background') === 'false') {
      return;
    }
    if (event.target === this.backgroundTarget) this.close()
  }

  submitEnd(e) {
    if (e.detail.success) {
      this.close()
    }
  }

  close () {
    super.close()
    this.dispatch('close')

    if (this.hasTurboFrameTarget) {
      this.turboFrameTarget.src = null
      this.turboFrameTarget.innerHTML = ''
    }
  }
}
